(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uk-drops"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var RANK = { live: 0, upcoming: 1, sold_out: 2 };
    var LABEL = { live: 'A la venta', upcoming: 'Próximamente', sold_out: 'Agotado' };

    // "2026-10-05 10:00" read as Madrid time, whatever the visitor's timezone.
    function madridDate(str) {
      var m = String(str || '').match(/(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?/);
      if (!m) return null;
      var guess = Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0));
      try {
        var f = new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Europe/Madrid', hour12: false,
          year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'
        });
        var parts = {};
        f.formatToParts(new Date(guess)).forEach(function (x) { parts[x.type] = x.value; });
        var asMadrid = Date.UTC(+parts.year, +parts.month - 1, +parts.day, +parts.hour % 24, +parts.minute);
        return new Date(guess - (asMadrid - guess));
      } catch (e) {
        return new Date(guess);
      }
    }

    var stampFmt = null;
    try {
      stampFmt = new Intl.DateTimeFormat('es-ES', {
        timeZone: 'Europe/Madrid', weekday: 'short', day: 'numeric', month: 'short',
        hour: '2-digit', minute: '2-digit', hour12: false
      });
    } catch (e) {}

    function pad(n) { return (n < 10 ? '0' : '') + n; }

    function setup(root) {
      if (root.dataset.ready === '1') return;
      root.dataset.ready = '1';
      var items = Array.prototype.slice.call(root.querySelectorAll('.uk-drop'));
      if (!items.length) return;

      items.forEach(function (li) {
        var d = madridDate(li.dataset.release);
        li._t = d ? d.getTime() : 0;
        var stamp = li.querySelector('[data-drop-date]');
        if (stamp) stamp.textContent = d ? (stampFmt ? stampFmt.format(d).replace(/,/g, '') + ' h' : li.dataset.release) : 'Ya disponible';

        var open = li.querySelector('[data-drop-notify-open]');
        var panel = li.querySelector('[data-drop-notify]');
        if (open && panel) {
          open.addEventListener('click', function () {
            panel.hidden = !panel.hidden;
            open.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');
            if (!panel.hidden) {
              var input = panel.querySelector('input[type="email"]');
              if (input) input.focus();
            }
          });
        }
      });

      // After a sign-up the page reloads at the form: reopen it to show the confirmation.
      if (window.location.hash.indexOf('uk-drop-form-') !== -1) {
        var form = document.getElementById(window.location.hash.slice(1));
        var panel = form && form.closest('[data-drop-notify]');
        if (panel) panel.hidden = false;
      }

      function stateFor(li, now) {
        var forced = li.dataset.status;
        if (forced && forced !== 'auto') return forced;
        if (li._t && now < li._t) return 'upcoming';
        return li.dataset.available === 'false' ? 'sold_out' : 'live';
      }

      function sort() {
        items.slice().sort(function (a, b) {
          var ra = RANK[a.dataset.state] || 0, rb = RANK[b.dataset.state] || 0;
          if (ra !== rb) return ra - rb;
          return (a._t || 0) - (b._t || 0);
        }).forEach(function (li, i) { li.style.order = i; });
      }

      var timer = null;
      function tick(first) {
        var now = Date.now();
        var changed = !!first;
        var anyUpcoming = false;
        items.forEach(function (li) {
          var prev = li.dataset.state;
          var s = stateFor(li, now);
          if (prev !== s || first) {
            li.dataset.state = s;
            var chip = li.querySelector('[data-drop-chip]');
            if (chip) chip.textContent = LABEL[s] || '';
            if (!first && prev === 'upcoming' && s === 'live') {
              li.classList.add('is-just-live');
              var t = li.querySelector('.uk-drop__title');
              if (window.ukToast && t) window.ukToast(t.textContent + ' ya está a la venta');
            }
            changed = true;
          }
          var out = li.querySelector('[data-drop-timer]');
          if (!out) return;
          if (s === 'upcoming' && li._t) {
            anyUpcoming = true;
            var diff = Math.max(0, li._t - now);
            var days = Math.floor(diff / 864e5);
            var h = Math.floor(diff / 36e5) % 24;
            var m = Math.floor(diff / 6e4) % 60;
            var sec = Math.floor(diff / 1e3) % 60;
            var text = (days ? days + 'd ' : '') + pad(h) + 'h ' + pad(m) + 'm' + (days ? '' : ' ' + pad(sec) + 's');
            out.hidden = false;
            out.innerHTML = 'Sale en <strong>' + text + '</strong>';
          } else {
            out.hidden = true;
          }
        });
        if (changed) sort();
        if (!anyUpcoming && timer) { clearInterval(timer); timer = null; }
      }

      tick(true);
      timer = setInterval(tick, 1000);
    }

    function init(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-uk-drops]'), setup);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
